import PageNotFound from '@/components/elements/PageNotFound/PageNotFound'
import React from 'react'

const VistaSealIt = () => {
    return (
        <>
            <PageNotFound />
        </>
    )
}

export default VistaSealIt